import type { SelectOptionType, SelectValueType } from '../../type';
import type { IPageAnalyticsForFilter } from '../types';

import { EReportControlId } from '~/presentation/reports/common/type';

export const mapPageToOption = (page: IPageAnalyticsForFilter): SelectOptionType => ({
  label: page.pageTitle,
  value: page.locationPath,
  description: page.locationPath,
});

export const isOperatorConfig = (id: string): boolean => {
  return id === EReportControlId.PAGE_OPERATOR;
};

export const getValueArray = (value?: SelectValueType): string[] => {
  if (!value) return [];

  return Array.isArray(value) ? value : [value];
};
